<template>
    <div id="us-upload-picture">
      <div v-if="showPicture">
        <viewer :images="pictures">
          <v-row style="padding-left:1.2rem;padding-right:0.8rem;">
            <v-col cols="4" style="position:relative;padding:0.5rem;" v-for="(p,index) in pictures" :key="index">
              <div style="width:100px;height:100px;">
                <img :src="p.PICTURE_THUMB_URL" :data-original="p.PICTURE_URL" alt="A" class="img-rounded" style="width:100%;height:100%;margin-top:0.5rem;border-radius:5px;" />
                <i class="fa fa-minus-circle" aria-hidden="true" style="font-size:1.5rem;position:absolute;top:0.3rem;right:-0.4rem;color:#f56c6c;" @click="removePicture(index)"></i>
              </div>
            </v-col>
            <v-col v-if="waitPicture" cols="4" style="padding:0.5rem;">
              <div style="width:100px;height:100px;">
                <div style="width:100%;height:100%;margin-top:0.5rem;border-radius:5px;background: #eee;">
                  <v-progress-circular color="#ffffff80" indeterminate style="width: 60px;height: 60px;margin-top: 20px;margin-left: 20px;"></v-progress-circular>
                </div>
              </div>
            </v-col>
            <v-col cols="4" style="padding:0.5rem;text-align:center;" @click="clickChoosePicture">
              <!-- <i class="fa fa-plus-square-o" aria-hidden="true" style="font-size:5rem;color: rgba(0, 0, 0, 0.6);"></i> -->
              <div style="height:100px;width:100px;">
                <img src="/res/icon/upload.png" style="width:100%;height:100%;margin-top:0.5rem;" alt="upload">
              </div>
            </v-col>
          </v-row>
        </viewer>
        <input type="file" id="us-file-input" accept="image/png, image/jpeg, image/bmp" multiple="multiple" style="display:none;" @change="changePicture" ref="pictureInput" >
      </div>
      <div v-else style="height:6.2rem;width:6.2rem;padding-top:0.33rem;">
        <img src="/res/icon/upload.png" style="width:100%;height:100%;" alt="upload" @click="clickChoosePicture">
      </div>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  props: {
    showPicture: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pictures: [],
      maxCount: 9,
      waitPicture: false
    }
  },
  computed: {
  },
  mounted() {

  },
  created() {
  },
  methods: {
    // 没用
    changePicture() {

      var that = this;

      var inputer = that.$refs.pictureInput;

      for (var i = 0; i < inputer.files.length; i++) {

        var lfile = inputer.files[i];

        var picSrc = window.URL.createObjectURL(lfile);

        that.pictures.push({ src: picSrc, data: lfile });
      }
    },
    removePicture(index) {
      var that = this
      that.pictures.splice(index, 1);
    },
    getPictureList() {
      return this.pictures
    },
    clickChoosePicture() {
      var that = this
      var chooseCount = that.maxCount - that.pictures.length
      if (chooseCount <= 0) {
        that.$toast.warning('最多只能上传' + that.maxCount + '张照片');
        return
      }
      wx.chooseImage({
        count: chooseCount, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function(res) {
          var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          that.waitState(true)
          that.uploadPicture(localIds);
        }
      });
    },
    // 上传图片
    uploadPicture(localIds) {
      var that = this

      if (localIds.length === 0) {
        return;
      }

      var v = localIds.pop();

      wx.uploadImage({
        localId: v, // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: function(res) {
          var serverId = res.serverId; // 返回图片的服务器端ID
          that.$api.bz.uploadGzPicture({ media_id: serverId }).then(result => {
            that.waitState(false)
            if (!result.success) {
              console.log('上传故障图片失败.res', result);
              that.$toast.warning('上传失败');
              return
            }
            var data = result.data
            that.$emit('uploadComplete', data)
            // data.PICTURE_URL = that.$api.bz.getGzPictureUrl(data.PICTURE_URL)
            // data.PICTURE_THUMB_URL = that.$api.bz.getGzPictureUrl(data.PICTURE_THUMB_URL)
            that.pictures.push(data)
            // that.uploadPicture(localIds)
          })
        },
        fail: function(res) {
          console.log('微信上传接口失败', res)
          that.waitState(false)
          that.$toast.warning('上传失败');
        }
      });
    },
    // 获取图片数据
    getPictureData(localIds) {
      var that = this
      console.log('localIds', localIds.length);
      if (localIds.length === 0) {
        return;
      }

      var v = localIds.pop();
      console.log('v', v);
      wx.getLocalImgData({
        localId: v, // 图片的localID
        success: function(res) {
          var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
          console.log('localData', localData);
          var lfile = that.convertBase64UrlToBlob(localData)

          var picSrc = window.URL.createObjectURL(lfile);

          that.pictures.push({ src: picSrc, data: lfile });

          that.getPictureData(localIds);
        }
      });
    },
    /**
     * 将以base64的图片url数据转换为Blob
     * @param urlData
     * 用url方式表示的base64图片数据
     */
    convertBase64UrlToBlob(urlData) {

      var bytes = window.atob(urlData.split(',')[1]); // 去掉url的头，并转换为byte

      // 处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], { type: 'image/png' });
    },
    init() {
      var that = this
      that.pictures = []
    },
    waitState(v) {
      var that = this
      if (!v) {
        v = false
      } else {
        v = true
      }
      if (that.showPicture) {
        that.waitPicture = v
      } else {
        that.$emit('waitComplete', v)
      }
    }

  }
}
</script>

<style scoped>
</style>
